import React from "react";

export default function ProductCatalogEmptyRow({ colSpan, children }) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-3 py-8 text-center text-gray-600">
        {children}
      </td>
    </tr>
  );
}
